import { matchPath } from 'react-router-dom';

type GetIsActive = (pathname: string, to: string, isActiveFor: string[]) => boolean;

export const getIsActive: GetIsActive = (pathname, to, isActiveFor) =>
  pathname === to || !!isActiveFor.find(route => matchPath(route, pathname));
